import axiosInstance from "@/utils/axiosInstance";
import { wrapFetchValue } from "@/store/modules/storeCache";

const baseUrl = `api/categories`;

const state = {};

const getters = {};

const mutations = {};

const actions = {
  getAll({ commit }, payload: { query: object }) {
    return wrapFetchValue(state, "categories",
      () => axiosInstance.get(baseUrl, { params: payload ? payload.query : {} })
      .then((data) => data.data));
  },
  getTagsFromCategory({ commit }, payload: { id: number }) {
    return axiosInstance.get(`${baseUrl}/${payload.id}/tags`)
      .then((data) => data.data);
  },
};

export default {
  namespaced: true, state, getters, actions, mutations,
};
